/*
 * @Description:
 * @Author: ywj
 * @Date: 2025-03-06 17:23:06
 * @LastEditTime: 2025-04-18 13:49:38
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoIcon from './imgs/logo.svg';
import orderPic from './imgs/order.png';
import ProcessTips from '../process-tips';
import './index.scss';

interface IHeaderProps {
  title: string;
  isCheckOrder?: boolean;
}
const Header: React.FC<IHeaderProps> = (props) => {
  const { title, isCheckOrder = false } = props;
  const navigate = useNavigate();
  const handleHome = () => {
    navigate('/home');
  };
  return (
    <div className="personal-header-container">
      <div className="personal-header-content">
        <div className="home-box-top">
          <div className="home-box-top-left">
            <div className="classify-box">
              <img src={logoIcon} alt="logo" className="logo" onClick={handleHome} />
              <div className="classify">
                <span className="classify-text">{title}</span>
              </div>
            </div>
          </div>
          <div className="home-box-top-right">
            {isCheckOrder && <ProcessTips
              width={ 235}
             startText='填写核对订单' 
             endText='成功提交订单'/>
              // <>
              // <img src={orderPic} alt="订单" />
              // <div className="img-text">
              //   <span>填写核对订单</span>
              //   <span>成功提交订单</span>
              // </div>
              // </>
            }
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Header;
